import type { QueryMassActionRequestArgs } from '@tribeplatform/gql-client/types'
import type { MassActionRequestFields } from '@tribeplatform/gql-client/types/generated'

import { KeyConstructor } from './keyConstructor.js'

const MASS_ACTION_REQUEST_KEY = 'massActionRequest'
const MASS_ACTION_REQUEST_IN_PROGRESS_KEY = 'massActionRequestInProgress'

export const getMassActionRequestKey = KeyConstructor<
  QueryMassActionRequestArgs,
  MassActionRequestFields
>(MASS_ACTION_REQUEST_KEY)

export const getMassActionRequestInProgressKey = KeyConstructor<
  never,
  MassActionRequestFields
>(MASS_ACTION_REQUEST_IN_PROGRESS_KEY)
